export class MapStructTileRenderParamsDTO {
  constructor() {
    this.tileElement = null;
    this.struct = null;
  }
}